import React, { useState, KeyboardEvent, LegacyRef, useEffect } from 'react';
import "./InputEmailField.scss";

interface Tag {
  id: number;
  text: string;
}

interface IProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  icon?: string;
  numeric?: boolean;
  floating?: boolean;
  innerRef?: LegacyRef<HTMLInputElement>;
  showHideButton?: boolean;
  errors?: string[];
  commaList?: boolean;
  defaultValue?: string;
  maxEmailsPerLine?: number;
  setEmails: Function;
}

const InputEmailField = ({
  label,
  icon,
  numeric,
  floating,
  innerRef,
  showHideButton, // icon and hide button share the same place so don"t use them together on one input.
  errors,
  commaList,
  defaultValue,
  maxEmailsPerLine = 5,
  setEmails,
  ...props
}: IProps) => {
  const [tags, setTags] = useState<Tag[]>([]);
  const [inputValue, setInputValue] = useState<string>('');


  useEffect(() => {
    if (defaultValue) {
      const emails = defaultValue.split(',').map(email => email.trim()).filter(email => validateEmail(email));
      setTags(emails.map(email => ({ id: Date.now() + Math.random(), text: email })));
    }
  }, [defaultValue]);

  const handleKeyUp = (event: KeyboardEvent<HTMLInputElement>) => {
    if (event.key === 'Enter' || event.key === ',') {
      const email = inputValue.trim().replace(',', '');
      if (email && validateEmail(email)) {
        setTags([...tags, { id: Date.now(), text: email }]);
        setInputValue('');
      }
    }
  };
  const handleBlur = () => {
    addTag();
  };

  const addTag = () => {
    const email = inputValue.trim().replace(',', '');
    if (email && validateEmail(email)) {
      setTags([...tags, { id: Date.now(), text: email }]);
      setInputValue('');
    }
  };

  useEffect(()=> {
    setEmails(tags.map(tag => tag.text).join(", "))
  }, [setEmails, tags]);

  const handleRemoveTag = (id: number) => {
    setTags(tags.filter(tag => tag.id !== id));
  };

  const validateEmail = (email: string) => {
    const re =    /^[\w-\\.\\+]+@((\[\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email);
  };

  const renderTags = () => {
    const lines = [];
    for (let i = 0; i < tags.length; i += maxEmailsPerLine) {
      lines.push(tags.slice(i, i + maxEmailsPerLine));
    }
    return lines.map((line, index) => (
      <div key={index} className="tag-line">
        {line.map(tag => (
          <div key={tag.id} className="tag">
            <span>{tag.text}</span>
            <span className="close" onClick={() => handleRemoveTag(tag.id)}>&times;</span>
          </div>
        ))}
      </div>
    ));
  };

  return (
    <>
      {label && <label className="input-field__label">{label}</label>}
      <div className="tag-container" >
        {renderTags()}
        <input
          {...props}
          type="email"
          className="tag-input"
          value={inputValue}
          onChange={(e) => {
            setInputValue(e.target.value)
            if (props.onChange) {
              props.onChange(e);
            }
          }}
          onKeyUp={handleKeyUp}
          onBlur={handleBlur}
        />
      </div>
    </>
  );
};

export default InputEmailField;